import { CommonAction, MainAction } from '../types/action-types';
import { getMainAction, getAllMainActions } from './main-action-registry';
import { getCommonAction, getAllCommonActions } from './common-action-registry';

/**
 * Factory class for action-related operations
 * Follows Factory pattern for extensibility
 */
export class ActionFactory {
    /**
     * Get main action metadata
     */
    static getMainAction(id: MainAction) {
        return getMainAction(id);
    }

    /**
     * Get all main actions
     */
    static getAllMainActions(includeSysAdminOnly: boolean = false) {
        return getAllMainActions(includeSysAdminOnly);
    }

    /**
     * Get common action metadata
     */
    static getCommonAction(id: CommonAction) {
        return getCommonAction(id);
    }

    /**
     * Get all common actions
     */
    static getAllCommonActions(includeSysAdminOnly: boolean = false) {
        return getAllCommonActions(includeSysAdminOnly);
    }

    /**
     * Check if an action is a complex action (replaces entire content)
     */
    static isComplexAction(mainActionId: MainAction): boolean {
        const action = getMainAction(mainActionId);
        return action?.isComplex ?? false;
    }
}

